export const searchByType = {
  LOCATION: 'location',
  CAMPSITE: 'campsite',
};

export const MY_LOCATION_SEARCH_KEY = 'my-location'; // used for Session Storage and URL query params.

export const defaultSearchByTypeUk = searchByType.CAMPSITE;
export const defaultSearchByTypeOverseas = searchByType.LOCATION;

export const GOOGLE_FEATURE_TYPES = {
  COUNTRY: 'COUNTRY',
  ADMINISTRATIVE_AREA_LEVEL_1: 'ADMINISTRATIVE_AREA_LEVEL_1',
  ADMINISTRATIVE_AREA_LEVEL_2: 'ADMINISTRATIVE_AREA_LEVEL_2',
  LOCALITY: 'LOCALITY',
};

// These are the feature types we will show borders for
export const APPLICABLE_FEATURE_TYPES = [
  GOOGLE_FEATURE_TYPES.COUNTRY,
  GOOGLE_FEATURE_TYPES.ADMINISTRATIVE_AREA_LEVEL_1,
  GOOGLE_FEATURE_TYPES.ADMINISTRATIVE_AREA_LEVEL_2,
];
